import { render, staticRenderFns } from "./GpBadge.vue?vue&type=template&id=799f6a94&"
import script from "./GpBadge.vue?vue&type=script&lang=js&"
export * from "./GpBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports